import { createSlice } from "@reduxjs/toolkit";
import { fetchPendingTransfer } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const pendingTransferSlice = createSlice({
  name: "Pending Transfer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingTransfer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingTransfer.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchPendingTransfer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default pendingTransferSlice.reducer;
